import { request } from '@/utils/request'

export const InterviewQuestionService = {
    async list(interviewId) {
        return await request.get(`/api/interviews/${interviewId}/questions`)
    },
}
